import { api } from '@/lib/api';
import type {
  IApiResponse,
  IFamilyMaturity,
  MaturityStatus,
} from '@skystone/shared';

/**
 * HTTP client for the family-maturity sub-resource of Management View
 * (PRODOPSAI-391 / US5).
 *
 * - `list` — GET /management-view/maturity. Auth required, no role gate.
 * - `update` — PUT /management-view/maturity/:familyCode. Admin-only.
 *
 * The api wrapper is configured at module level — endpoints here are passed
 * WITHOUT the `/api` prefix per CLAUDE.md (the wrapper adds it).
 */
export const familyMaturityApi = {
  list: async (): Promise<IFamilyMaturity[]> => {
    const result = await api.get<IApiResponse<IFamilyMaturity[]>>(
      '/management-view/maturity',
    );
    return result.data;
  },
  update: async (
    familyCode: string,
    status: MaturityStatus,
  ): Promise<IFamilyMaturity> => {
    const result = await api.put<IApiResponse<IFamilyMaturity>>(
      `/management-view/maturity/${familyCode}`,
      { status },
    );
    return result.data;
  },
};
